export const FMI_NUMBER_FORMAT = '0,0';
export const FMI_PERCENT_FORMAT = '0%';
